export default __webpack_public_path__ + "static/university-of-amsterdam-03c4a4955b20979ef8d2af206e2bb7cc.png";